import * as $ from 'jquery';
import { disposableSubscription } from 'common/barrels/core';

import { LooklessControl } from 'runtime/controls/looklesscontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { GenericEvent } from 'runtime/events/genericevent';
import { registerBinding } from 'runtime/bindingengine';

export class CardReader extends LooklessControl {
    private respond: boolean;

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.respond = this.config['content.RespondToEvents'];

        var genericEvents = this.eventAggregator.query(GenericEvent).filter(() => this.respond).share();

        this.subscriptions = disposableSubscription(
            genericEvents.filter(x => x.name === 'CardRead').subscribe(x => this.processCardRead(x)),
            genericEvents.filter(x => x.name === 'CardReadError').subscribe(() => this.triggerEvent('CardReadError')),
            genericEvents.filter(x => x.name === 'CardReaderOnline').subscribe(() => this.triggerEvent('CardReaderOnline')),
            genericEvents.filter(x => x.name === 'CardReaderOffline').subscribe(() => this.triggerEvent('CardReaderOffline')),
            this.processBindings(this.config)
        );
    }

    readCard() {
        this.eventAggregator.publish(new GenericEvent('ReadCard', ''));
    }

    checkReaderStatus() {
        this.eventAggregator.publish(new GenericEvent('CheckReaderStatus', ''));
    }

    private processCardRead(event: GenericEvent) {
        var payload = JSON.parse(event.payload);
        this.$element.triggerHandler('content.CardNumber', payload.CardNumber);
        this.triggerEvent('CardRead');
    }


    'content.RespondToEvents'(value: boolean) {
        this.respond = value;
    }

    'content.CardNumber'() { }
}

registerBinding('cardreader', CardReader);